import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
// import { FaTrash } from "react-icons/fa";
// import { MdEditSquare } from "react-icons/md";
import ConfirmationModal from '../../components/common/confirm/ConfirmationModal';
import AdminLoader from '../../components/common/loader/AdminLoader';
// import { FaUserCircle } from "react-icons/fa";
// import { MdLogout } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
// import { logoutSession } from '../../store/slices/sessionSlice';
import { updateLeadType, addLeadType, deleteLeadType, fetchLeadTypes } from './../../store/slices/leadTypeSlice';
import { setCurrentPageTitle } from '../../store/slices/pageSlice';
import { MdSearch } from "react-icons/md";
import { SquarePen, Trash2 } from "lucide-react";
import { CiCircleCheck } from "react-icons/ci";

const LeadType = () => {

    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        dispatch(setCurrentPageTitle("Lead Types"));
    }, [dispatch]);

    const [isLoading, SetisLoading] = useState(false);
    const [filteredLeadTypes, setFilteredLeadTypes] = useState([]);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [showLogout, setshowlogout] = useState(false);
    const popupRef = useRef(null);
    // const name = localStorage.getItem("name");

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setshowlogout(false); // Close the popup if clicked outside
        }
    };
    useEffect(() => {
        if (showLogout) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showLogout]);


    const token = localStorage.getItem('token');
    if (!token) {
        enqueueSnackbar('Login to Navigate!', { variant: 'error' });
        navigate('/');
    }

    const [LeadType, setLeadType] = useState('');
    const [editingLeadTypeId, setEditingLeadTypeId] = useState(null);
    const [LeadTypes, setLeadTypes] = useState([]);

    const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux)
    const dropdownsRef = useRef(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
            if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
                // Also check if the click was on the ellipsis icon itself
                const clickedElement = event.target;
                const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');

                if (!isEllipsisIcon) {
                    setOpenDropdownId(null);
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdownId]);
    useEffect(() => {
        dispatch(fetchLeadTypes())
    }, [dispatch])

    useEffect(() => {
        setLeadTypes(leadTypesRedux)
    }, [leadTypesRedux])

    const editLeadType = (id, LeadTypeName) => {
        setEditingLeadTypeId(id);
        setLeadType(LeadTypeName);
    };

    const Submit = async (e) => {
        e.preventDefault();

        if (!LeadType) {
            enqueueSnackbar('Please fill all the fields!', { variant: 'error' });
            return;
        }

        SetisLoading(true);

        try {
            if (!editingLeadTypeId) {
                // **Dispatch Add Lead Type Action**
                const newLeadType = await dispatch(addLeadType(LeadType)).unwrap();
                enqueueSnackbar('Lead Type Added Successfully!', { variant: 'success' });

                setLeadType('');
                setLeadTypes([...LeadTypes, newLeadType]); // Update Local State
            } else {
                // **Dispatch Update Lead Type Action**
                const updatedLeadType = await dispatch(updateLeadType({ id: editingLeadTypeId, LeadType })).unwrap();
                enqueueSnackbar('Lead Type Updated Successfully!', { variant: 'success' });

                setLeadType('');
                setEditingLeadTypeId(null);
                setLeadTypes(LeadTypes.map(type => (type.id === editingLeadTypeId ? updatedLeadType : type))); // Update Local State
            }
        } catch (error) {
            console.error("Error:", error);
            if (error?.error) {
                enqueueSnackbar(error?.error, { variant: "error" });
            } else if (error?.error) {
                enqueueSnackbar(error?.error, { variant: "error" });
            } else {
                enqueueSnackbar("Something went wrong!", { variant: "error" });
            }
        } finally {
            SetisLoading(false);
        }
    };

    const handleDeleteLeadType = async (id) => {
        try {
            // **Dispatch Redux Action to Delete Lead Type**
            await dispatch(deleteLeadType(id)).unwrap();

            // **Show Success Message**
            enqueueSnackbar('Lead Type Deleted Successfully!', { variant: 'success' });

            // **Update Local State Without Reloading**
            setLeadTypes((prevLeadTypes) => prevLeadTypes.filter(type => type.id !== id));

        } catch (error) {
            enqueueSnackbar(error || 'Failed to delete Lead Type!', { variant: 'error' });
        }
    };

    const Cancel = (e) => {
        e.preventDefault();
        setLeadType('');
        setEditingLeadTypeId(null);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [leadTypetoDelete, setleadTypetoDelete] = useState(null);

    const openDeleteModal = (id) => {
        setleadTypetoDelete(id);
        setIsModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsModalOpen(false);
        setleadTypetoDelete(null);
    };

    const confirmDelete = async () => {
        if (leadTypetoDelete) {
            await handleDeleteLeadType(leadTypetoDelete);  // Call your existing delete function
        }
        closeDeleteModal();
    };


    useEffect(() => {
        if (searchQuery.trim() === '') {
            setFilteredLeadTypes(LeadTypes);
        } else {
            const filtered = LeadTypes.filter(leadType =>
                leadType.LeadType.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredLeadTypes(filtered);
        }
    }, [searchQuery, LeadTypes]);

    const handleSearchInputChange = (e) => {
        const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");

        setSearchQuery(value);

    };

    return (
        <>
            <div className=" bg-[#f3f8f8] pb-6 h-screen">
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onClose={closeDeleteModal}
                    onConfirm={confirmDelete}
                />
                {isLoading && (
                    <AdminLoader isLoading={isLoading} />
                ) }
                    <div className="relative flex justify-center align-middle items-center pt-2">
                        <div className='flex flex-col relative w-[80%] gap-4'>
                            {/* Page Title */}
                            <div className="flex items-center gap-2">
                                <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                                <h1 className="text-2xl font-semibold">Add Lead Type</h1>
                            </div>

                            <div className='flex gap-2'>
                            <div className='w-[40%] bg-white rounded-md h-fit'>
                                <div className="flex px-3 py-4 gap-2 align-middle items-center border-b">
                                    <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                                    <h2 className="font-semibold text-xl">
                                        Lead Information
                                    </h2>
                                </div>
                                <div className="mainform px-3 py-2 flex flex-col gap-3">
                                    <div>
                                        <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                            Lead Type Name <span className="text-red-700 text-xs">*</span>
                                        </div>
                                        <div>
                                            <input
                                                className='border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs'
                                                type="text"
                                                placeholder='e.g. Quote, RFP, Contract'
                                                value={LeadType}
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '').slice(0, 30)
                                                    setLeadType(newValue);
                                                }
                                                } />
                                        </div>
                                        <div className="p-1">
                                            <p className="text-xs text-[#606060]">Enter a clear, descriptive name for the lead type</p>
                                        </div>
                                    </div>
                                    <div className="flex gap-2 text-xs">
                                        <button
                                            onClick={Submit}
                                            className="p-1 flex align-middle items-center gap-2 px-4 bg-[#0f61e6] hover:bg-blue-400 overflow-hidden text-white rounded-lg"
                                        >
                                            <CiCircleCheck size={16} />
                                            {editingLeadTypeId ? "Update Type" : "Add Type"}
                                        </button>
                                        <button 
                                            onClick={Cancel} 
                                            className="py-2 px-3 border border-[#e5e7eb] bg-white overflow-hidden rounded-lg"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='w-[60%] p-4 bg-white rounded-md'>
                                <div className="flex justify-between align-middle items-center py-2">
                                    <div className="flex items-center gap-3 shrink-0">
                                        <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                                        <h1 className="text-lg font-semibold text-gray-900">
                                            Lead Types Directory
                                        </h1>
                                    </div>

                                    <div className="flex gap-2 p-2 align-middle items-center border border-[#e5e7eb] rounded-lg">
                                        <MdSearch className="w-5 h-5 text-gray-500" />
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={handleSearchInputChange}
                                            placeholder="Search"
                                            className="w-full outline-none text-sm text-gray-900 placeholder-gray-500"
                                        />
                                    </div>
                                </div>
                                <hr />
                                <hr />
                                <br />
                                <div className="maintable min-h-[10rem] max-h-[60vh] overflow-auto">



                                    <table className="min-w-full divide-y divide-gray-200 border text-xs">
                                        <thead className='bg-[#e8e8e8] sticky top-0 z-50 font-semibold'>
                                            <tr>
                                                <th className="border p-2 text-start tracking-wider font-medium capitalize">Sr.no.</th>
                                                <th className="border p-2 text-start tracking-wider font-medium capitalize">Lead Type</th>
                                                <th className="border p-2 text-center tracking-wider font-medium capitalize">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className='bg-white divide-y divide-gray-200'>
                                            {filteredLeadTypes.length > 0 ? (
                                                filteredLeadTypes.map((LeadType, index) => (
                                                    <tr className='border border-gray-400' key={index}>
                                                        <td className="px-2 border-b text-start py-2">{index + 1}</td>
                                                        <td className="px-2 text-start border-b py-2">{LeadType.LeadType}</td>
                                                        <td className="px-2 border-b text-center py-2">
                                                            <div className="flex justify-center items-center gap-3">
                                                                <div
                                                                    onClick={() => editLeadType(LeadType.id, LeadType.LeadType)}
                                                                    className="cursor-pointer hover:opacity-70"
                                                                    title="Edit"
                                                                >
                                                                    <SquarePen size={18} className="text-blue-500" />
                                                                </div>
                                                                <div
                                                                    onClick={() => openDeleteModal(LeadType.id)}
                                                                    className="cursor-pointer hover:opacity-70"
                                                                    title="Delete"
                                                                >
                                                                    <Trash2 size={18} className="text-blue-500" />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center text-red-500 py-4">
                                                        {searchQuery.trim() === ''
                                                            ? 'No lead types available'
                                                            : 'No matching lead types found'}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

                
            </div>
        </>
    );
};

export default LeadType;
